import axios from "axios";
import { headers, reqErrorHandler, reqHandler, resErrorHandler, resHandler } from "../common/axiosUtil";
import properties from '../../config/environmentProperties';
console.log("ENV", properties.currentEnvironment.depType);
const essApi = axios.create({
    baseURL: properties.currentEnvironment.esspRootUrl + properties.currentEnvironment.esspApi, headers
});

essApi.interceptors.request.use(reqHandler, reqErrorHandler);
essApi.interceptors.response.use(resHandler, resErrorHandler);

export default essApi;
